import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/HomeView.vue"),
  },
  {
    path: "/products",
    name: "Products",
    component: () => import("@/views/ProductsView.vue"),
  },
  // {
  //   path: "/product/:id",
  //   name: "ProductDetail",
  //   component: () => import("@/views/ProductsDetail.vue"),
  // },
  {
    path: "/product/:slug",
    name: "ProductDetail",
    component: () => import("@/views/ProductsDetail.vue"),
  },
  {
    path: "/cart",
    name: "Cart",
    component: () => import("@/views/CartView.vue"),
  },
  {
    path: "/about",
    name: "About",
    component: () => import("@/views/AboutView.vue"),
  },
  {
    path: "/order-success",
    component: () => import("@/views/OrderSuccess.vue"),
  },
  {
    path: "/return-policy",
    name: "ReturnPolicy",
    component: () => import("@/views/PolicyView.vue"),
  },

  // {
  //   path: "/contact",
  //   name: "Contact",
  //   component: () => import("@/views/ContactUsView.vue"),
  // },
];

const router = createRouter({
  history: createWebHistory(),
  routes,

  // ✅ THIS IS THE FIX
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

export default router;
